"use strict";
/*
 * Created on 31.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../DomainObject");
/**
 * Class which represents change of data of entity or its workflow state. Intended use is not for audit log,
 * but history of important entity changes for users in application.
 *
 * @author MSu
 */


var EntityChange =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EntityChange, _DomainObject_1$Domai);

  /**
   * Constructs new EntityChange.
   * @param id automatically created by mongo
   * @param user user who made change
   * @param changeSetId ID of set of changes
   * @param changeDate date time of change
   * @param changeType identification of change type
   * @param relatedIds IDs of entities for which this change is important
   * @param entityId ID of changed entity
   * @param entityClass class of changed entity; used for obtaining of converter from IoC Container
   * @param oldState entity workflow state before change
   * @param newState entity workflow state after change
   * @param oldData entity before change
   * @param newData entity after change
   * @param detailsClass class of entity with details of entity change; used for obtaining of converter from IoC Container
   * @param detailsData object with details of entity change
   */
  function EntityChange(id, user, changeSetId, changeDate, changeType) {
    var _this;

    var relatedIds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : immutable_1.List.of();
    var entityId = arguments.length > 6 ? arguments[6] : undefined;
    var entityClass = arguments.length > 7 ? arguments[7] : undefined;
    var oldState = arguments.length > 8 ? arguments[8] : undefined;
    var newState = arguments.length > 9 ? arguments[9] : undefined;
    var oldData = arguments.length > 10 ? arguments[10] : undefined;
    var newData = arguments.length > 11 ? arguments[11] : undefined;
    var detailsClass = arguments.length > 12 ? arguments[12] : undefined;
    var detailsData = arguments.length > 13 ? arguments[13] : undefined;

    _classCallCheck(this, EntityChange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityChange).call(this));
    _this.id = id;
    _this.user = user;
    _this.changeSetId = changeSetId;
    _this.changeDate = changeDate;
    _this.changeType = changeType;
    _this.relatedIds = relatedIds;
    _this.entityId = entityId;
    _this.entityClass = entityClass;
    _this.oldState = oldState;
    _this.newState = newState;
    _this.oldData = oldData;
    _this.newData = newData;
    _this.detailsClass = detailsClass;
    _this.detailsData = detailsData;
    return _this;
  }

  return EntityChange;
}(DomainObject_1.DomainObject);

exports.EntityChange = EntityChange;